module.exports = function getResource(label, vars = []) {
    const resources = {
        giftOptionsAutoReplenishMessage: 'Gift options are unavailable for Auto-Replenish items.'
    };

    return resources[label];
};
